
declare const gapi: any;
import { onMounted } from "vue";
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
import ScriptService from "../../../services/loadScript.service";
@Options({})
export default class LoginGoogle extends Base {
  onMounted = onMounted(() => {
    ScriptService.loadMeta("google-signin-client_id");
    ScriptService.loadScript("render_Button_GG").then(() => {
      gapi.signin2.render("google-signin-button", {
        scope: "profile email",
        width: 240,
        height: 50,
        longtitle: true,
        theme: "dark",
        onsuccess: this.onSuccess,
        onFailure: this.onFailure
      });
    });
  });

  onSuccess(googleUser: any) {
    console.log("Logged in as: " + googleUser.getBasicProfile().getName());
  }

  onFailure(error: any) {
    console.log(error);
  }
}
